<template>
  <img alt="Cart loading spinner" id="cart-loader" :src="spinner180" />
</template>
<script setup>
import spinner180 from '@/assets/ux/180-spinner.svg';
</script>
<style scoped>
#cart-loader {
  height: 35px;
  filter: invert(33%) sepia(38%) saturate(5832%) hue-rotate(208deg) brightness(97%) contrast(103%);
}
</style>
